import { config } from "./config";
import { offline } from "./offline";
import { screensaver } from "./screensaver";
import { session } from "../../shared/timeclock/reducers/session";
import { signatures } from "./signatures";

import { combineReducers } from "redux";

export const rootReducer = combineReducers({
    config,
    signatures,
    session,
    screensaver,
    offline
});

export * from "./config";
export * from "../../shared/timeclock/reducers/session";
export * from "./signatures";

export type RootState = ReturnType<typeof rootReducer>
